module.exports = __webpack_public_path__ + "img/Professional-2.f34f0778.gif";